import type { ReactNode } from 'react';

/** Persistent, touch-friendly help; no hover gesture is needed to read it. */
export default function FieldHint({ id, children }: { id?: string; children: ReactNode }) {
  return (
    <span
      id={id}
      className="mt-1.5 block text-xs font-normal leading-relaxed text-muted-foreground"
    >
      {children}
    </span>
  );
}
